<template>
  <div class="container">
    <div class="row nav">
      <router-link class="tab four columns" :to="{name:'Admin'}" exact>カード管理</router-link>
      <router-link class="tab four columns" :to="{name:'UserAdmin'}" exact>ユーザー追加・編集</router-link>
    </div>

    <router-view></router-view>
  </div>
</template>
<script>
// @ is an alias to /src


export default {
  name: 'Admin',
  data() {
    return{
    }
  },
  created: function(){

  },
  methods: {
  }
}
</script>

<style scoped>
.nav{
  margin-top: 2rem;
  border-bottom: solid 3px #bae8e8;
}
.tab{
  background: #e3f6f5;
  border-radius: 10px 10px 0 0;
  padding: 5px;
  margin-left: 2px;
  text-align: center;
  text-decoration: none;
  color: #4e4f4f;
}
.router-link-active{
  background: #bae8e8;
  box-shadow: 1px -1px 1px rgba(0,0,0,.3);
}
@media (max-width: 699px) {
  .nav{
    border-bottom: none;
  }
  .tab{
    border-radius: 10px;
    margin: 5px;
  }
}
</style>